var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"form-control",attrs:{"type":"file","id":_vm.id,"accept":"image/*"},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.preview)?_c('img',{staticClass:"img-responsive",staticStyle:{"max-height":"100px"},attrs:{"src":_vm.preview}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }